import type { QuestionnaireItem } from '@medplum/fhirtypes'
import { SENSITIVE_QUESTIONNAIRE_ITEM } from '#src/codeSystems.ts'

export const isSensitiveQuestionnaireItem = (
  item: QuestionnaireItem
): boolean =>
  item.extension?.some(
    (ext) =>
      ext.url === SENSITIVE_QUESTIONNAIRE_ITEM && ext.valueBoolean === true
  ) ?? false
